/**
 * MSAL (Microsoft Authentication Library) configuration for Azure AD authentication.
 * 
 * Client App Registration: 86198637-04de-44a5-982d-a181fef30af9
 * API App Registration:    8f768add-a064-4af3-b160-5b43e18b8e33
 * Tenant:                  7bb63ee7-a3e1-4d75-b5a5-6f9549f171a3
 */

import { LogLevel } from '@azure/msal-browser';

const TENANT_ID = '7bb63ee7-a3e1-4d75-b5a5-6f9549f171a3';
const CLIENT_ID = '86198637-04de-44a5-982d-a181fef30af9';

/**
 * MSAL configuration object
 */
export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin, // http://localhost:3000 or production URL
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage', // Persist across tabs
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message);
            break;
          case LogLevel.Warning:
            console.warn('[MSAL]', message);
            break;
          case LogLevel.Info:
            console.info('[MSAL]', message);
            break;
          case LogLevel.Verbose:
            console.debug('[MSAL]', message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Scopes to request when acquiring tokens for the backend API.
 * These must match the scopes exposed by the API app registration.
 */
export const apiScopes = {
  read: 'api://p2s-resource-allocation/Allocations.Read',
  write: 'api://p2s-resource-allocation/Allocations.Write',
};

/**
 * Login request configuration — request both scopes during login
 */
export const loginRequest = {
  scopes: [apiScopes.read, apiScopes.write],
  prompt: 'select_account',
};

/**
 * Token request for API calls
 */
export const tokenRequest = {
  scopes: [apiScopes.read, apiScopes.write],
};
